import React from 'react';
import { ISystem, ISystemGroup } from './types';

export interface IDashContext {
  systems: ISystem[];
  groups: ISystemGroup[];
}

export const DashContext = React.createContext<IDashContext>({ systems: [], groups: [] });
DashContext.displayName = 'Dashboard Context';
